import angular from 'angular';
/**
 * Modulo para las incidencias
 */
import EnvioEntidadService from "./enviosEntidadesService";
import EntidadEnvioDetallesDirectiva from "./entidadesEnviosDetallesDirectiva";
import EntidadEnvioDetallesCtrl from "./entidadesEnviosDetallesCtrl";
import AddEditEntidadEnvioDialogCtrl from "./addEditEntidadEnvioDialogCtrl";
import ngResourceModuleName from 'angular-resource';

const EnviosEntidadesModule = angular
    .module('enviosEntidades', [ngResourceModuleName])
    .service('EnvioEntidad', EnvioEntidadService)
    .directive('entidadesEnvios', EntidadEnvioDetallesDirectiva)
    .controller('EntidadEnvioDetallesCtrl', EntidadEnvioDetallesCtrl)
    .controller('AddEditEntidadEnvioDialogCtrl', AddEditEntidadEnvioDialogCtrl)
;
export default EnviosEntidadesModule;